import { finish, error } from '../../../modules/transactions/actions/assign';
import { request as getWithdrawals } from '../../../modules/customers/actions/get-transactions';
import api from '../../../api';
import moment from 'moment';

export function request(dispatch, { accountId, id, data }) {
    api.patch('/transactions/' + accountId + '/' + id, data).then(
        (transaction) => {
            let conditions = Object.assign({
                type: 'withdrawal',
                status: [ 'requested', 'assigned', 'failed' ],
                period: {
                    startDate: moment().subtract(7, 'days').format('YYYY-MM-DDT00:00:00'),
                    endDate: moment().format('YYYY-MM-DDT23:59:59')
                }
            });

            dispatch(finish(id, transaction));
            dispatch(getWithdrawals(accountId, 'pending-withdrawals', conditions));
        },
        ({ errors }) => dispatch(error(id, errors))
    );
}
